require('./morningStarCopyright.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { FormattedText } = require('core/i18n').i18n;
const morningStarLogo = require('assets/images/logo-morningstar.png');

const MorningStarCopyright = (
        fromFunds
) => {
    if (fromFunds) {
        return (
            <div className="morning-star-copyright__content-disclaimer">
                <div className="morning-star-copyright__copyright-text">
                    <p className="morning-star-copyright">
                        <FormattedText value="morningStar-copyright" />&nbsp;
                        <FormattedText value="morningStar-morningStar" />&nbsp;
                        <FormattedText value="morningStar-allRightsReserved" />
                        <FormattedText value="morningStar-pleaseRead" />&nbsp;
                        <FormattedText value="morningStar-termsAndConditions" />
                    </p>
                </div>
            </div>
        )
    } else {
        return (
            <p className="morning-star-copyright">
                <a className="morning-star-copyright__link" href="#">
                    <FormattedText value="morningStar-copyright" />
                </a>
                <img className="morning-star-copyright__logo" src={morningStarLogo} />
                <FormattedText value="morningStar-allRightsReserved" />
                <FormattedText value="morningStar-pleaseRead" />&nbsp;
                <a className="morning-star-copyright__link" href="">
                    <FormattedText value="morningStar-termsAndConditions" />
                </a>
            </p>
        );
    }


};


MorningStarCopyright.propTypes = {
    fromFunds: PropTypes.bool,
};


module.exports = MorningStarCopyright;
